/**
 * Ability clip library entry: registers the reference defaults and every class's clips once.
 * The hero views call `registerAllClips()` before resolving a clip.
 */
import { registerBlademasterClips } from './classes/blademaster';
import { registerLightbinderClips } from './classes/lightbinder';
import { registerStormcallerClips } from './classes/stormcaller';
import { registerWardenClips } from './classes/warden';
import { registerDefaultClips } from './defaults';
import { registerDodgeClip } from './kits/dodge';
import { registerJumpClip } from './kits/jump'; // +jump
import { registerAutoAttackClips } from './kits/autoattack'; // +autoattack

let registered = false;

export function registerAllClips(): void {
  if (registered) return;
  registered = true;
  registerDefaultClips();
  registerWardenClips();
  registerLightbinderClips();
  registerBlademasterClips();
  registerStormcallerClips();
  registerDodgeClip();
  registerJumpClip(); // +jump
  registerAutoAttackClips(); // +autoattack
}

export * from './clips';
export * from './registry';
export { CLASS_LOOK } from './defaults';
